module.exports = __webpack_public_path__ + "public/SiteIcons/15.svg?1be3aadd";